import { connect } from "react-redux";
import EdexLogo from "../../../assets/images/Ed_EX_logo_plain.png";
import PreLoginBanner from "../../../assets/images/pre_login_banner.png";
import "./preLoginContainer.scss";

const PreLoginContainer = ({ children, global, showLoginMessage = false }) => {
  let logo = EdexLogo;
  let banner = PreLoginBanner;
  if (global.enterprise && global.enterprise.logo) {
    logo = global.enterprise.logo;
  }

  if (global.enterprise && global.enterprise.preLoginBanner) {
    banner = `${new URL(
      global.enterprise.preLoginBanner,
      process.env.REACT_APP_URL
    ).toString()}`;
  }

  return (
    <div className="pre-login-container">
      <div className="pre-login-contents">
        <div className="pre-login-logo flex flex-column align-items-center">
          {((!global.enterprise || !global.enterprise.logo) && (
            <img src={EdexLogo} alt="Logo" className="logo" />
          )) || (
            <img
              src={`${new URL(logo, process.env.REACT_APP_URL).toString()}`}
              alt="Logo"
              className="logo"
            />
          )}
          {(showLoginMessage &&
            ((global?.enterprise?.preLoginMessage && (
              <div className="title text-center">
                <div className="tag-line">
                  {global?.enterprise?.preLoginMessage || ""}
                </div>
              </div>
            )) ||
              null)) ||
            null}
        </div>
        <div className="pre-login-content">{children}</div>
        <div className="footer">
          <div className="powered-by">
            <span className="text-muted">Powered by</span>
            <img src={EdexLogo} alt="Powered By" className="powered-by-logo" />
          </div>
        </div>
      </div>
      <div className="pre-login-bg">
        <img src={banner} alt="Pre Login Banner" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  global: state.global,
});

export default connect(mapStateToProps)(PreLoginContainer);
